import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DriverSearchComponent } from './driver-search/driver-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material';
import { DeliveryShipperUiAppToolbarModule } from '@fleetoperate/delivery-shipper/ui-app-toolbar';

@NgModule({
  declarations: [DriverSearchComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSliderModule,
    DeliveryShipperUiAppToolbarModule
  ]
})
export class DriverSearchModule {}
